$(document).ready(function () {
	if ($(".new_driver_selector_tool").length) {
		$('#driverSelect').steps({
			headerTag: 'h3',
			bodyTag: 'section',
			transitionEffect: 'slideLeft',
			stepsOrientation: 'vertical'
		});

		$.fn.steps.setStep = function (step) {
			var currentIndex = $(this).steps('getCurrentIndex');
			for (var i = 0; i < Math.abs(step - currentIndex); i++) {
				if (step > currentIndex) {
					$(this).steps('next');
				}
				else {
					$(this).steps('previous');
				}
			}
		};


		var recDriver = '';
		var idDriver = '';
		var userDistance = '';
		var Loft = '';
		var LoftD = '';
		var Flex = '';
		var Trajectory = '';
		var Shaft = '';
		var Grip = 'Tour Wrap Grip';
		var GripSize = '';
		var Gender = '';
		var Hand = '';
		var Length = '';

		/*setTimeout(function(){ 
			$('.video-player1')[0].contentWindow.postMessage('{"event":"command","func":"' + 'unMute' + '","args":""}', '*');
		}, 5000);*/

		$(".steps ul a").click(function (event) {
			var i;
			for (i = 1; i < 3; i++) {
				$('.video-player' + i)[0].contentWindow.postMessage('{"event":"command","func":"' + 'stopVideo' + '","args":""}', '*');
			}
			console.log("videos stoped")
		});
		$('.btnpr').click(function (event) {
			$('.btnpr').removeClass('btn-driver-type');
			$(this).addClass('btn-driver-type');
			$('.recommendation-container .pro-item').addClass('hidden');
			if ($(this).attr('data-dtype') == 'x') {
				$('.pro-item-48').removeClass('hidden');
			}
			else if ($(this).attr('data-dtype') == 'xx') {
				$('.pro-item-47').removeClass('hidden');
			}
			else {
				$('.pro-item-49').removeClass('hidden');
			}
		});
		$('.btn-select, .btn-trajectory').click(function (event) {

			event.preventDefault();
			console.clear();
			window.scrollTo({ top: 0, behavior: 'smooth' });

			//If is video stop before moving on
			if ($(this).hasClass('is-video')) {
				var video_id = $(this).data('video');

				if (video_id == "1") {
					setTimeout(function () {
						$('.video-player1')[0].contentWindow.postMessage('{"event":"command","func":"' + 'playVideo' + '","args":""}', '*');
					}, 500);
					setTimeout(function () {
						$('.video-player1')[0].contentWindow.postMessage('{"event":"command","func":"' + 'unMute' + '","args":""}', '*');
					}, 800);
				}
				if (video_id == "2") {
					setTimeout(function () {
						$('.video-player2')[0].contentWindow.postMessage('{"event":"command","func":"' + 'playVideo' + '","args":""}', '*');
					}, 500);
				}

			}

			//Set selected driver
			if ($(this).hasClass('btn-driver-type')) {
				recDriver = $(this).data('dtype');
			}


			//set distance
			// Gagan
			if ($(this).hasClass('btn-current-distance')) {
				userDistance = $('input#currentDistance').val();
				console.log(userDistance);
				//If XX
				if (recDriver == "xx") {

					switch (true) {
						case (userDistance <= 150):
							Loft = '14';
							Flex = 'Senior Flex';
							Shaft = 'Fujikura Speeder X Light Tour';
							break;
						case (userDistance <= 199):
							Loft = '12';
							Flex = 'Senior Flex';
							Shaft = 'Fujikura Speeder X Light Tour';
							break;
						case (userDistance >= 200):
							Swal.fire({
								title: 'Invalid Distance',
								text: 'This average driving distance exceeds what is recommended for this driver. Please select the Formula FIRE X (200-249 Yards) Driver for this distance.',
								icon: 'error',
								confirmButtonText: 'OK'
							}).then(() => {
								$("#driverSelect").steps("setStep", 4);
							});
							return false;

						case (userDistance >= 261):
							Swal.fire({
								title: 'Distance Exceeded',
								text: 'This average driving distance exceeds what is recommended for this driver. Please select the Formula FIRE PRO Driver for this distance.',
								icon: 'error',
								confirmButtonText: 'OK'
							}).then(() => {
								$("#driverSelect").steps("setStep", 4);
							});
							return false;

					}

				}

				//If X
				// Gagan
				if (recDriver == "x") {

					switch (true) {
						case (userDistance <= 199):
							Swal.fire({
								title: "Recommendation",
								text: "For this average driving distance we recommend choosing the Formula FIRE XX (0-199 Yards) Driver to maximize your distance",
								icon: 'error',
								confirmButtonText: "OK"
							}).then(() => {
								$("#driverSelect").steps("setStep", 4);
							});
							return false;
						case (userDistance >= 200 && userDistance <= 249):
							Flex = 'Stiff Flex';
							Shaft = 'Fujikura Speeder X Light Tour';
							break;
						case (userDistance >= 211 && userDistance <= 240):
							Flex = 'Regular Flex';
							Shaft = 'Fujikura Speeder X Light Tour';
							break;
						case (userDistance >= 241 && userDistance <= 249):
							Flex = 'Stiff Flex';
							Shaft = 'Fujikura Speeder X Light Tour';
							break;
						case (userDistance >= 250):
							Swal.fire({
								title: "Distance Exceeded",
								text: "This average driving distance exceeds what is recommended for this driver. Please select the Formula FIRE PRO Driver for this average driving distance.",
								icon: 'error',
								confirmButtonText: "OK"
							}).then(() => {
								$("#driverSelect").steps("setStep", 4);
							});
							return false;
					}

				}

				//If Pro
				// Gagan
				if (recDriver == "pro") {

					switch (true) {
						case (userDistance <= 150):
							Flex = 'Senior Flex';
							Shaft = 'Fujikura Speeder X Light Tour';
							break;
						case (userDistance >= 151 && userDistance <= 210):
							Flex = 'Senior Flex';
							Shaft = 'Fujikura Speeder X Light Tour';
							break;
						case (userDistance >= 211 && userDistance <= 240):
							Flex = 'Regular Flex';
							Shaft = 'Fujikura Speeder X Light Tour';
							break;
						case (userDistance >= 241 && userDistance <= 260):
							Flex = 'Stiff Flex';
							Shaft = 'Fujikura Speeder X Light Tour';
							break;
						case (userDistance >= 261 && userDistance <= 305):
							Flex = 'Stiff Flex';
							Shaft = 'Fujikura Speeder X Tour';
							break;
						case (userDistance >= 306):
							Flex = 'X Flex';
							Shaft = 'Fujikura Speeder X Tour';
							break;
					}

				}

			}

			//Set Loft
			// Gagan
			if ($(this).hasClass('btn-current-loft')) {
				var userCurrentLoft = $('input#currentLoft').val();

				//If X
				if (recDriver == "x") {
					switch (true) {
						case (userCurrentLoft < 10):
							Loft = '9'
							break;
						case (userCurrentLoft < 11):
							Loft = '10.5'
							break;
						case (userCurrentLoft > 11):
							Loft = '12'
							break;
					}
				}

				//If Pro
				// Gagan
				if (recDriver == "pro") {
					switch (true) {
						case (userCurrentLoft <= 6):
							Swal.fire({
								title: "Loft Unavailable",
								text: "The loft you are currently playing is available in the Formula FIRE LD TOUR (Long Drive) Driver. Please contact Krank Golf directly for that loft availability.",
								icon: 'error',
								confirmButtonText: "OK"
							}).then(() => {
								// Do nothing further; prevent progress
							});
							return false;
						case (userCurrentLoft <= 8):
							Loft = '7.5'
							break;
						case (userCurrentLoft <= 10):
							Loft = '9'
							break;
						case (userCurrentLoft <= 11):
							Loft = '10.5'
							break;
						case (userCurrentLoft > 11 && userCurrentLoft <= 15):
							Loft = '12'
							break;
						case (userCurrentLoft > 15):
							Loft = '12'
							break;
					}
				}

				LoftD = Loft;

			}

			//Set Trajectory
			if ($(this).hasClass('btn-trajectory')) {

				//HIGH
				if ($(this).hasClass('btn-traj-high')) {

					//If X
					if (recDriver == "x") {
						switch (true) {
							case (Loft == "12"):
								Loft = '10.5'
								break;
							case (Loft == "10.5"):
								Loft = '9'
								break;
						}
					};

					//If Pro
					if (recDriver == "pro") {
						switch (true) {
							case (Loft == "12"):
								Loft = '10.5'
								break;
							case (Loft == "10.5"):
								Loft = '9'
								break;
							case (Loft == "9"):
								Loft = '7.5'
								break;
						}
					};

				}
				//if($(this).hasClass('btn-traj-mid-high')){ }

				//MID
				if ($(this).hasClass('btn-traj-mid')) {


				}
				//if($(this).hasClass('btn-traj-mid-low')){ }

				//LOW
				if ($(this).hasClass('btn-traj-low')) {

					//If X
					if (recDriver == "x") {
						switch (true) {
							case (Loft == "9"):
								Loft = '10.5'
								break;
							case (Loft == "10.5"):
								Loft = '12'
								break;
						}
					};

					//If Pro
					if (recDriver == "pro") {
						switch (true) {
							case (Loft == "7.5"):
								Loft = '9'
								break;
							case (Loft == "9"):
								Loft = '10.5'
								break;
							case (Loft == "10.5"):
								Loft = '12'
								break;
						}
					};

				}

				LoftD = Loft;

			}

			//Set Shaft
			if ($(this).hasClass('btn-current-shaft')) {
				if ($(this).hasClass('btn-cshaft-womens')) { }
				if ($(this).hasClass('btn-cshaft-senior-light')) { }
				if ($(this).hasClass('btn-cshaft-regular')) { ; }
				if ($(this).hasClass('btn-cshaft-stiff')) { }
				if ($(this).hasClass('btn-cshaft-extra-stiff')) { }
			}


			//Set Grip
			if ($(this).hasClass('btn-grip-size-1') || $(this).hasClass('btn-grip-size-2') || $(this).hasClass('btn-grip-size-3')) {
				if ($(this).hasClass('btn-grip-size-1')) { GripSize = 'Regular'; }
				if ($(this).hasClass('btn-grip-size-2')) { GripSize = 'Mid'; }
				if ($(this).hasClass('btn-grip-size-3')) { GripSize = 'Jumbo'; }
			}

			//Set Height
			if ($(this).hasClass('btn-height')) {
				var userHeight = (parseInt($('input#userHeightFt').val()) * 12) + parseInt($('input#userHeightIn').val());
				switch (true) {
					case (userHeight <= 56):

						break;
					case (userHeight <= 60):

						break;
					case (userHeight <= 65):

						break;
					case (userHeight <= 76):

						break;
					case (userHeight <= 78):

						break;
					case (userHeight <= 81):

						break;
					case (userHeight <= 83):

						break;
					default:

						break;
				}

			}


			//Set Gender
			if ($(this).hasClass('btn-men')) { Gender = 'Men'; }
			if ($(this).hasClass('btn-women')) { Gender = 'Women'; }


			//Set hand
			if ($(this).hasClass('btn-hand-right')) { Hand = 'Right'; }
			if ($(this).hasClass('btn-hand-left')) { Hand = 'Left'; }

			//Set Length
			//If XX
			if (recDriver == "xx") {
				if (Gender == 'Men') {
					Length = '45.5';
				}
				if (Gender == 'Women') {
					Length = '44.5';
				}
			}

			//If X
			if (recDriver == "x") {
				if (Gender == 'Men') {
					Length = '45.5';
				}
				if (Gender == 'Women') {
					Length = '44.5';
				}
			}

			//If X
			if (recDriver == "pro") {
				if (Gender == 'Men') {
					Length = '45.5';
				}
				if (Gender == 'Women') {
					Length = '44.5';
				}
			}


			// FINISH
			if ($(this).hasClass('btn-finish')) {

				//alert(recDriver);
				switch (recDriver) {
					case 'xx':
						selectBase = V2_DST_DRIVER3;
						idDiver = V2_DST_DRIVER3_ID;
						break;
					case 'x':
						selectBase = V2_DST_DRIVER2;
						idDiver = V2_DST_DRIVER2_ID;
						break;
					case 'pro':
						selectBase = V2_DST_DRIVER4;
						idDiver = V2_DST_DRIVER4_ID;
						break;
				}

				switch (Hand) {
					case 'Right':
						if (recDriver == 'xx') {
							selectBase = V2_DST_DRIVER3;
							idDiver = V2_DST_DRIVER3_ID;
						}
						else if (recDriver == 'x') {
							selectBase = V2_DST_DRIVER2;
							idDiver = V2_DST_DRIVER2_ID;
						}
						else {
							selectBase = V2_DST_DRIVER4;
							idDiver = V2_DST_DRIVER4_ID;
						}
						attrHand = '?attribute_hand=1';
						break;
					case 'Left':
						if (recDriver == 'xx') {
							selectBase = "/products/formula-fire-xx_left-hand_super_high-cor";
							idDiver = V2_DST_DRIVER3_ID;
						}
						else if (recDriver == 'x') {
							selectBase = "/products/formula-fire-x_left_hand_high-cor";
							idDiver = V2_DST_DRIVER2_ID;
						}
						else {
							selectBase = "/products/formula-fire-pro_usga-conforming-left-hand";
							idDiver = V2_DST_DRIVER4_ID;
						}

						attrHand = '?attribute_hand=1';
						break;
					default:
						attrHand = '?attribute_hand=1';
						break;
				}


				//Initial loft attributes
				// Gagan
				switch (Loft) {
					case '7.5':
						attrLoft = '&attribute_loft=1';
						break;
					case '9':
						attrLoft = '&attribute_loft=2';
						break;
					case '10.5':
						attrLoft = '&attribute_loft=3';
						break;
					case '12':
						LoftD = '10.5';
						attrLoft = '&attribute_loft=4';
						break;
					case '14':
						attrLoft = '&attribute_loft=5';
						break;
					default:
						attrLoft = '&attribute_loft=1';
						break;
				}

				//If X or XX Loft attributes
				// Gagan
				if (recDriver == "x" || recDriver == "xx") {
					switch (Loft) {
						case '9':
							attrLoft = '&attribute_loft=1';
							break;
						case '10.5':
							attrLoft = '&attribute_loft=2';
							break;
						case '12':
							LoftD = '10.5+ (12) Degree';
							attrLoft = '&attribute_loft=3';
							break;
						case '14':
							attrLoft = '&attribute_loft=4';
							break;

					}
				}

				switch (Shaft) {
					case 'Fujikura Speeder X Light Tour':
						attrShaft = '&attribute_shaft=1';
						break;
					case 'Fujikura Speeder X Tour':
						attrShaft = '&attribute_shaft=2';
						break;
					default:
						attrShaft = '&attribute_shaft=1';
						break;
				}

				switch (Flex) {
					case 'Regular Flex':
						attrFlex = '&attribute_flex=2';
						break;
					case 'X Flex':
						attrFlex = '&attribute_flex=5';
						break;
					case 'Stiff Flex':
						attrFlex = '&attribute_flex=4';
						break;
					case 'Firm Flex':
						attrFlex = '&attribute_flex=3';
						break;
					case 'Senior Flex':
						attrFlex = '&attribute_flex=1';
						break;
					case 'Senior 2 Flex':
						attrFlex = '&attribute_flex=6';
						break;
					case "Women's Flex":
						attrFlex = '&attribute_flex=7';
						break;
					default:
						attrFlex = '&attribute_flex=1';
						break;
				}

				switch (Length) {
					case '44':
						attrLength = '&attribute_length=1';
						break;
					case '44.5':
						attrLength = '&attribute_length=2';
						break;
					case '45':
						attrLength = '&attribute_length=3';
						break;
					case '45.5':
						attrLength = '&attribute_length=4';
						break;
					case '46':
						attrLength = '&attribute_length=5';
						break;
					case '46.5':
						attrLength = '&attribute_length=6';
						break;
					case '47':
						attrLength = '&attribute_length=7';
						break;
					default:
						attrLength = '&attribute_length=8';
						break;
				}

				switch (Grip) {
					case 'Tour Wrap Grip':
						attrGrip = '&attribute_grip=1';
						break;
					default:
						attrGrip = '&attribute_grip=1';
						break;
				}

				switch (GripSize) {
					case 'Regular':
						attrGripSize = '&attribute_grip_size=1';
						break;
					case 'Mid':
						attrGripSize = '&attribute_grip_size=2';
						break;
					case 'Jumbo':
						attrGripSize = '&attribute_grip_size=3';
						break;
					default:
						attrGripSize = '&attribute_grip_size=1';
						break;
				}



				var productURL = selectBase + attrHand + attrLoft + attrFlex + attrShaft + attrLength + attrGrip + attrGripSize + '#productInfo';
				$('a#findMyDriver').attr('href', productURL);
				//$('.pro-item').addClass('hidden');

				if (idDiver != '') { $('a.btn-product-' + idDiver).attr('href', productURL); }


				$('a#findMyDriver').removeClass('btn-disabled');
				// Fill Product Data
				$('.rec-data-gender').html(Gender);
				$('.rec-data-hand').html(Hand);
				// 517 Swap to Original Fire images for Left Hand
				if (Hand === 'Left') {
					// PRO
					$('.pro-item-49 .pro-item-image').attr('src', 'https://862be0-ef.myshopify.com/cdn/shop/files/all-heads-face-with-shafts-PRO.webp?v=1726758315');
					$('.pro-item-49 .pro-item-image').attr('alt', 'Formula FIRE PRO - USGA Conforming - Rated For Average Drives up to and beyond 250 yards');
					$('.pro-item-49 .pro-item-title').text('Formula FIRE PRO - USGA Conforming - Rated For Average Drives up to and beyond 250 yards');
					$('.btn-product-49').attr('href', '/products/formula-fire-pro_usga-conforming-left-hand');

					// X
					$('.pro-item-48 .pro-item-image').attr('src', 'https://862be0-ef.myshopify.com/cdn/shop/files/all-heads-face-with-shafts-X.webp?v=1726758314');
					$('.pro-item-48 .pro-item-image').attr('alt', 'Formula FIRE X High COR Driver - Rated For Average Drives between 200 - 249 Yards');
					$('.pro-item-48 .pro-item-title').text('Formula FIRE X High COR Driver - Rated For Average Drives between 200 - 249 Yards');
					$('.btn-product-48').attr('href', '/products/formula-fire-x_left_hand_high-cor');

					// XX
					$('.pro-item-47 .pro-item-image').attr('src', 'https://862be0-ef.myshopify.com/cdn/shop/files/all-heads-face-with-shafts-XX.webp?v=1726758314');
					$('.pro-item-47 .pro-item-image').attr('alt', 'Formula FIRE XX Super High COR Driver - Rated For Average Drives of 199 Yards or Less');
					$('.pro-item-47 .pro-item-title').text('Formula FIRE XX Super High COR Driver - Rated For Average Drives of 199 Yards or Less');
					$('.btn-product-47').attr('href', '/products/formula-fire-xx_left-hand_super_high-cor');
				}

				// 517 Remove "Tour" from titles if hand is Left
				$('.pro-item').each(function () {
					const handText = $(this).find('.rec-data-hand').text().toLowerCase();
					const $title = $(this).find('.pro-item-title');

					if (handText.includes('left') && $title.length && $title.text().includes('Tour')) {
						const newText = $title.text().replace(/\bTour\b/gi, '').replace(/\s{2,}/g, ' ').trim();
						$title.text(newText);
					}
				});
				// 517 END Remove "Tour" from titles if hand is Left

				$('.rec-data-loft').html(LoftD);
				$('.rec-data-shaft').html(Shaft);
				$('.rec-data-flex').html(Flex);
				$('.rec-data-length').html(Length);
				$('.rec-data-grip').html(Grip);
				$('.rec-data-grip-size').html(GripSize);

				if ($(".contact-form").length > 0) {

					$('input#data-sex').val(Gender);
					$('input#data-hand').val(Hand);
					$('input#data-loft').val(LoftD);
					$('input#data-shaft').val(Shaft);
					$('input#data-flex').val(Flex);
					$('input#data-length').val(Length);
					$('input#data-grip').val(Grip);
					$('input#grip-size').val(GripSize);
					$('input#data-driver-type').val(recDriver);
					$('input#data-recommendation').val(productURL);
				}
				console.log("ididv:" + idDiver);

			}


			console.log("recDriver:" + recDriver);
			console.log("userDistance:" + userDistance);
			console.log("Loft:" + LoftD);
			console.log("Flex:" + Flex);
			console.log("Trajectory:" + Trajectory);
			console.log("Shaft:" + Shaft);
			console.log("GripSize:" + GripSize);
			console.log("Gender:" + Gender);
			console.log("Hand:" + Hand);

			$('#driverSelect').steps('next');
		});



		$('.btn-plus').click(function (e) {
			e.preventDefault();
			fieldName = $(this).attr('field');
			var currentVal = parseInt($('input[name=' + fieldName + ']').val());
			if (!isNaN(currentVal)) {
				if ($(this).hasClass('btn-plus-25')) {
					$('input[name=' + fieldName + ']').val(currentVal + 25);
				} else if ($(this).hasClass('btn-plus-5')) {
					$('input[name=' + fieldName + ']').val(currentVal + 5);
				} else { $('input[name=' + fieldName + ']').val(currentVal + 1); }
			} else {
				$('input[name=' + fieldName + ']').val(0);
			}
		});

		$('.btn-minus').click(function (e) {
			e.preventDefault();
			fieldName = $(this).attr('field');
			var currentVal = parseInt($('input[name=' + fieldName + ']').val());
			if (!isNaN(currentVal) && currentVal > 0) {
				if ($(this).hasClass('btn-minus-25')) {
					$('input[name=' + fieldName + ']').val(currentVal - 25);
				} else if ($(this).hasClass('btn-minus-5')) {
					$('input[name=' + fieldName + ']').val(currentVal - 5);
				} else { $('input[name=' + fieldName + ']').val(currentVal - 1); }
			} else {
				$('input[name=' + fieldName + ']').val(0);
			}
		});

		$('.btn-plus-half').click(function (e) {
			e.preventDefault();
			fieldName = $(this).attr('field');
			var currentVal = parseFloat($('input[name=' + fieldName + ']').val());
			if (!isNaN(currentVal) && currentVal < 16) {
				$('input[name=' + fieldName + ']').val(currentVal + 0.5);
			} else {
				$('input[name=' + fieldName + ']').val(16);
			}
		});

		$('.btn-minus-half').click(function (e) {
			e.preventDefault();
			fieldName = $(this).attr('field');
			var currentVal = parseFloat($('input[name=' + fieldName + ']').val());
			if (!isNaN(currentVal) && currentVal > 1) {
				$('input[name=' + fieldName + ']').val(currentVal - 0.5);
			} else {
				$('input[name=' + fieldName + ']').val(1);
			}
		});


		$('.btn-trajectory').hover(function () {
			if ($(this).hasClass('btn-traj-high')) { $('img.traj-high').addClass('traj-active'); }
			if ($(this).hasClass('btn-traj-mid-high')) { $('img.traj-mid-high').addClass('traj-active'); }
			if ($(this).hasClass('btn-traj-mid')) { $('img.traj-mid').addClass('traj-active'); }
			if ($(this).hasClass('btn-traj-mid-low')) { $('img.traj-mid-low').addClass('traj-active'); }
			if ($(this).hasClass('btn-traj-low')) { $('img.traj-low').addClass('traj-active'); }
		}, function () {
			if ($(this).hasClass('btn-traj-high')) { $('img.traj-high').removeClass('traj-active'); }
			if ($(this).hasClass('btn-traj-mid-high')) { $('img.traj-mid-high').removeClass('traj-active'); }
			if ($(this).hasClass('btn-traj-mid')) { $('img.traj-mid').removeClass('traj-active'); }
			if ($(this).hasClass('btn-traj-mid-low')) { $('img.traj-mid-low').removeClass('traj-active'); }
			if ($(this).hasClass('btn-traj-low')) { $('img.traj-low').removeClass('traj-active'); }
		});


		$('input.tool-control-height').on('input', function () {
			if ($(this).val().length == $(this).attr('maxlength')) {
				console.log('focus next');
				if ($(this).hasClass('height-ft')) {
					if (!isNaN($('input#userHeightFt').val())) {
						if ($(this).val() < 7) { $('input#userHeightIn').focus(); } else { $('input#userHeightFt').val(''); $('input#userHeightFt').focus(); }
					} else {
						$('input#userHeightFt').val('');
						$('input#userHeightFt').focus();
					}

				}
				if ($(this).hasClass('height-in')) {
					if (!isNaN($('input#userHeightIn').val())) {
						if ($(this).val() < 12) { $('button.btn-height').prop('disabled', false); $('button.btn-height').focus(); } else { $('input#userHeightIn').val(''); $('input#userHeightIn').focus(); }
					} else {
						$('input#userHeightIn').val('');
						$('input#userHeightIn').focus();
					}

				}
			}
			if ($(this).hasClass('height-in')) {
				if ($(this).val().length >= 1) { $('button.btn-height').prop('disabled', false); }
			}
		});

		// COMPLETE FORM
		if ($('.driver-selector-container').hasClass('lead-gen')) {
			$('form').submit(function () {
				$('button.btn-form-complete').prop('disabled', false);
				$('button.btn-form-complete').focus();
			});
		}

		$('.btn-form-complete').click(function (event) {
			event.preventDefault();
			window.scrollTo({ top: 0, behavior: 'smooth' });
			$('#driverSelect').steps('next');
		});

	}

});